import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics';

/**
 * RouterGoogleAnalyticsTracker Component
 *
 * ⚠️ IMPORTANT: This component MUST be placed inside a Router component (BrowserRouter, etc.)
 * The name "Router" prefix indicates this component depends on React Router context.
 *
 * Purpose:
 * - Automatically tracks page views whenever the route changes
 * - Listens to location changes and sends them to Google Analytics
 *
 * Usage:
 * ```tsx
 * <BrowserRouter>
 *   <RouterGoogleAnalyticsTracker /> // ✅ Correct - Inside Router
 *   <Routes>...</Routes>
 * </BrowserRouter>
 * ```
 *
 * ❌ Will NOT work:
 * ```tsx
 * <RouterGoogleAnalyticsTracker /> // ❌ Error - Outside Router
 * <BrowserRouter>
 *   <Routes>...</Routes>
 * </BrowserRouter>
 * ```
 */
const RouterGoogleAnalyticsTracker: React.FC = () => {
  const location = useLocation(); // Requires Router context
  const { trackPageView } = useGoogleAnalytics();

  useEffect(() => {
    // HAT-1081: נשלח pathname בלבד - ה-querystring יכול לשאת PII
    // (למשל login-as?email=...) ואסור שיגיע ל-GA.
    trackPageView(location.pathname);
  }, [location, trackPageView]);

  // This component doesn't render anything, it just tracks
  return null;
};

export default RouterGoogleAnalyticsTracker;

